import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { ButtonModule } from './button.module';
/**
 * NgModule definition for the Button component with providers.
 */
export class ButtonAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ButtonModule],
    exports: [
        ButtonModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonAllModule_tsickle_Closure_declarations() {
/** @type {?} */
ButtonAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
